export default "__VITE_ASSET__DZBC_XVR__"